// State registry. Register a new state here by importing its module and adding
// it under its uppercase STATE_CODE key — no other file needs to change.
import { texas } from "./texas";

export const REGISTRY = {
  TX: texas,
};
